/*
 * Auto Complete Search Panel
 *
 **/

// Google Tag Manager DataLayer Helper
require('custom/gtm-datalayer');

custom.SearchPanel = (function () {
  // Variables
  var breakpoint = 768;
  const $searchPanel = $('.js-search-panel');
  const $inputSection = $searchPanel.find('.search-panel__input');
  const $resultSection = $searchPanel.find('.search-panel__results');
  const $trigger = $('.js-search-panel-trigger');
  const $closeBtn = $('.js-search-panel-close');
  const focusClass = 'js-search-panel-focused';
  const activeClass = 'js-search-panel-active';
  const overflowClass = 'overflow-hidden';
  const filterDropDownClass = 'js-filter-dropdown-open';

  function isMobile() {
    return $(window).width() < breakpoint;
  }

  function setResultSectionHeight() {
    const inputSectionHeight = $inputSection.outerHeight();
    const navHeight = isMobile() ? 0 : $('.navigation').outerHeight();

    $resultSection.css({
      height: 'calc(100vh - ' + (inputSectionHeight + navHeight) + 'px)',
    });
  }

  function clearResultSectionHeight() {
    $resultSection.css({
      height: '',
    });
  }

  function activatePanel() {
    if (!$('body').hasClass(activeClass)) {
      $('body').addClass(activeClass);
      setResultSectionHeight();
    }
  }

  function deactivePanel() {
    if ($('body').hasClass(activeClass)) {
      $('body').removeClass(activeClass);
      clearResultSectionHeight();
    }
  }

  function openPanel() {
    $('body').addClass(focusClass);
    $('body').addClass(overflowClass);
    setTimeout(() => {
      $inputSection.find('input[type="search"]').focus();
    }, 400);
    $('body').on('click', clickOutsideToClose);
    $('.navigation').addClass('white-background');
    $('#qab_bar').hide();
    $('#announcementBar').hide();
    const heightValue = !isMobile() ? '114px' : '84px';
    $('.navigation').css({
      height: heightValue,
      'padding-top': '0',
      top: '0',
    });
    $('.search-panel').css({
      top: heightValue,
    });
    if ($('body').hasClass(filterDropDownClass))
      $('body').removeClass(filterDropDownClass);
  }

  function closePanel() {
    let minNavHeight = 84;

    $('body').removeClass(focusClass);
    $('body').removeClass(overflowClass);
    $('body').removeClass(activeClass);
    setTimeout(() => {
      $inputSection.find('input[type="search"]').blur();
    }, 400);
    setTimeout(() => {
      $('.navigation').removeClass('white-background');
    }, 600);
    $('body').off('click', clickOutsideToClose);
    $('#qab_bar').show();
    $('#announcementBar').show();
    $('.navigation').css('padding-top', $('.announcement-bar').height());
    $('.navigation').css(
      'height',
      $('.announcement-bar').height() + minNavHeight,
    );
    $('.navigation').css('top', 'auto');
    $('.quick-cart').css('top', $('.announcement-bar').height() + minNavHeight);
  }

  function clickOutsideToClose(event = {}) {
    if (
      $(event.target).hasClass('js-navigation') ||
      $(event.target).hasClass('js-search-panel')
    )
      return;

    if (
      $(event.target).closest('.js-navigation').length ||
      $(event.target).closest('.js-search-panel').length
    )
      return;

    closePanel();
  }

  function togglePanel(event) {
    event.preventDefault();

    if (!$('body').hasClass(focusClass)) {
      openPanel();
      custom.gtmDatalayer.gtmPushElem($(event.currentTarget));
    } else if ($('body').hasClass(focusClass)) {
      closePanel();
    }
  }

  function removeEditorialDot() {
    const interval = setInterval(() => {
      var editorialTitles = $('.aa-dataset-articles .aa-title');
      $(editorialTitles).each(function (index, element) {
        if ($(element).text()[$(element).text().length - 1] == '.') {
          $(element).text($(element).text().slice(0, -1));
          clearInterval(interval);
        }
      });
    }, 100);
  }

  function init() {
    window.pubsub.on('openAutoCompleteDropdown', activatePanel);
    window.pubsub.on('closeAutoCompleteDropdown', deactivePanel);
    $('input[type=search]').first().on('input', removeEditorialDot);

    $trigger.on('click', togglePanel);
    $closeBtn.on('click', closePanel);
  }

  return {
    closePanel,
    init: init,
  };
})();

custom.SearchPanel.init();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/search-panel.js